import { TranslationStatus } from '@taxonomy-translation/types'

// TODO: Change the structure after refactoring the filter form
export const FILTERS = {
  STATUS: {
    MATCH: {
      label: 'match',
      value: TranslationStatus.Match,
    },
    NO_MATCH: {
      label: 'no match',
      value: TranslationStatus.NoMatch,
    },
    REVIEWED: {
      label: 'reviewed',
      value: TranslationStatus.Reviewed,
    },
    EXCLUDED: {
      label: 'excluded',
      value: TranslationStatus.Excluded,
    },
  },
  MATCH_CONFIDENCE: {
    NOT_CONFIDENCE: {
      label: '< 80% confidence',
      value: 'not_confidence',
    },
    FULL_CONFIDENCE: {
      label: '100% confidence',
      value: 'full_confidence',
    },
  },
}
